import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTravelFormData, removeTravelFormData as removeTravelFormDataAction, selectTravelFormData } from '../redux/features/newTravelFormSlice';

const useTravelFormData = (formKey, setFormState) => {
    const dispatch = useDispatch();
    const travelFormData = useSelector(selectTravelFormData);

    const saveTravelDataInRedux = useCallback((data) => {
        dispatch(setTravelFormData({ key: formKey, data }));
        if (setFormState) {
            setFormState(data);
        }
    }, [dispatch, formKey, setFormState]);

    const removeTravelFormData = useCallback(() => {
        dispatch(removeTravelFormDataAction(formKey));
    }, [dispatch, formKey]);

    const getTravelFormData = useCallback(() => {
        return travelFormData[formKey] || null;
    }, [travelFormData, formKey]);

    return {
        saveTravelDataInRedux,
        removeTravelFormData,
        getTravelFormData,
        travelFormData,
    };
};

export default useTravelFormData;